import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import cl from 'classnames';
import { useLanguage } from 'src/hooks';
import { Button, Modal, CalendarDate } from 'src/components/general';
import styles from './exportToXlsxStyle.module.scss';

const exportToXlsxIcon = (
  <div className={styles.icon}>
    <svg
      width="22"
      height="22"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_118)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.25 2.18254V22.8175C6.25 24.0228 7.21189 25 8.39844 25H22.8516C24.0381 25 25 24.0228 25 22.8175V5.74318C25 5.16017 24.7704 4.6014 24.3624 4.19143L20.8186 0.630791C20.4164 0.226664 19.8735 0 19.3078 0H8.39844C7.21189 0 6.25 0.977156 6.25 2.18254ZM7.61719 22.8175V2.18254C7.61719 1.74422 7.96697 1.38889 8.39844 1.38889H19.043V6.15079C19.043 6.97265 19.6988 7.63889 20.5078 7.63889H23.6328V22.8175C23.6328 23.2558 23.283 23.6111 22.8516 23.6111H8.39844C7.96697 23.6111 7.61719 23.2558 7.61719 22.8175ZM23.6328 6.25V5.74318C23.6328 5.53118 23.5493 5.32799 23.4009 5.1789L20.4102 2.17386V6.15079C20.4102 6.20558 20.4539 6.25 20.5078 6.25H23.6328Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0156 10.2539C16.0156 9.87637 16.3217 9.57031 16.6992 9.57031H21.1914C21.5689 9.57031 21.875 9.87637 21.875 10.2539C21.875 10.6314 21.5689 10.9375 21.1914 10.9375H16.6992C16.3217 10.9375 16.0156 10.6314 16.0156 10.2539Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0156 13.3789C16.0156 13.0014 16.3217 12.6953 16.6992 12.6953H21.1914C21.5689 12.6953 21.875 13.0014 21.875 13.3789C21.875 13.7564 21.5689 14.0625 21.1914 14.0625H16.6992C16.3217 14.0625 16.0156 13.7564 16.0156 13.3789Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.0156 16.5039C16.0156 16.1264 16.3217 15.8203 16.6992 15.8203H21.1914C21.5689 15.8203 21.875 16.1264 21.875 16.5039C21.875 16.8814 21.5689 17.1875 21.1914 17.1875H16.6992C16.3217 17.1875 16.0156 16.8814 16.0156 16.5039Z"
          fill="white"
        />
        <path
          d="M0 7.22656C0 6.57935 0.524666 6.05469 1.17188 6.05469H12.8906C13.5378 6.05469 14.0625 6.57935 14.0625 7.22656V18.9453C14.0625 19.5925 13.5378 20.1172 12.8906 20.1172H1.17187C0.524666 20.1172 0 19.5925 0 18.9453V7.22656Z"
          fill="white"
        />
        <path
          d="M3.90625 17.009L6.10123 12.9234L4.10919 9.17969H5.62592L6.91299 11.6951L8.17337 9.17969H9.67407L7.68204 12.9822L9.87701 17.009H8.31223L6.88629 14.3013L5.46036 17.009H3.90625Z"
          fill="#1F93FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_118">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

const exportToXlsxIconSmall = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_155)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 2.18254V22.8175C6.25 24.0228 7.21189 25 8.39844 25H22.8516C24.0381 25 25 24.0228 25 22.8175V5.74318C25 5.16017 24.7704 4.6014 24.3624 4.19143L20.8186 0.630791C20.4164 0.226664 19.8735 0 19.3078 0H8.39844C7.21189 0 6.25 0.977156 6.25 2.18254ZM7.61719 22.8175V2.18254C7.61719 1.74422 7.96697 1.38889 8.39844 1.38889H19.043V6.15079C19.043 6.97265 19.6988 7.63889 20.5078 7.63889H23.6328V22.8175C23.6328 23.2558 23.283 23.6111 22.8516 23.6111H8.39844C7.96697 23.6111 7.61719 23.2558 7.61719 22.8175ZM23.6328 6.25V5.74318C23.6328 5.53118 23.5493 5.32799 23.4009 5.1789L20.4102 2.17386V6.15079C20.4102 6.20558 20.4539 6.25 20.5078 6.25H23.6328Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0156 10.2539C16.0156 9.87637 16.3217 9.57031 16.6992 9.57031H21.1914C21.5689 9.57031 21.875 9.87637 21.875 10.2539C21.875 10.6314 21.5689 10.9375 21.1914 10.9375H16.6992C16.3217 10.9375 16.0156 10.6314 16.0156 10.2539Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0156 13.3789C16.0156 13.0014 16.3217 12.6953 16.6992 12.6953H21.1914C21.5689 12.6953 21.875 13.0014 21.875 13.3789C21.875 13.7564 21.5689 14.0625 21.1914 14.0625H16.6992C16.3217 14.0625 16.0156 13.7564 16.0156 13.3789Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0156 16.5039C16.0156 16.1264 16.3217 15.8203 16.6992 15.8203H21.1914C21.5689 15.8203 21.875 16.1264 21.875 16.5039C21.875 16.8814 21.5689 17.1875 21.1914 17.1875H16.6992C16.3217 17.1875 16.0156 16.8814 16.0156 16.5039Z"
        fill="white"
      />
      <path
        d="M0 7.22656C0 6.57935 0.524666 6.05469 1.17188 6.05469H12.8906C13.5378 6.05469 14.0625 6.57935 14.0625 7.22656V18.9453C14.0625 19.5925 13.5378 20.1172 12.8906 20.1172H1.17187C0.524666 20.1172 0 19.5925 0 18.9453V7.22656Z"
        fill="white"
      />
      <path
        d="M3.90625 17.009L6.10123 12.9234L4.10919 9.17969H5.62592L6.91299 11.6951L8.17337 9.17969H9.67407L7.68204 12.9822L9.87701 17.009H8.31223L6.88629 14.3013L5.46036 17.009H3.90625Z"
        fill="#DD7BC1"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_155">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const exportModes = ['selected', 'current', 'prev'] as const;
export type ExportMode = (typeof exportModes)[number];

type ExportSelectProps = {
  onExport: (move: ExportMode) => void;
  small?: boolean;
  className?: string;
  labelClassName?: string;
  style?: CSSProperties;
  isDisabled?: boolean | null;
};

export const ExportSelect = ({
  small = false,
  onExport,
  className,
  labelClassName,
  style,
  isDisabled = false,
  ...otherProps
}: ExportSelectProps &
  Partial<React.ButtonHTMLAttributes<HTMLButtonElement>>) => {
  const [expanded, setExpanded] = useState(false);
  const listRef = useRef<HTMLDivElement | null>(null);
  const { t, td } = useLanguage();

  useEffect(() => {
    const onDocumentClick = (event: Event) => {
      if (
        event.target instanceof Node &&
        listRef.current &&
        !listRef.current.contains(event.target)
      ) {
        setExpanded(false);
      }
    };

    if (expanded) {
      document.addEventListener('click', onDocumentClick);
    }

    return () => {
      if (expanded) {
        document.removeEventListener('click', onDocumentClick);
      }
    };
  }, [expanded]);

  return (
    <button
      onClick={(event) => {
        event.stopPropagation();

        if (isDisabled) {
          return;
        }

        setExpanded((prevState) => !prevState);
      }}
      className={cl(
        small ? styles.buttonSmall : styles.button,
        isDisabled && styles.disabled,
        className,
      )}
      type="button"
      style={style}
      {...otherProps}
    >
      {small ? exportToXlsxIconSmall : exportToXlsxIcon}
      <div className={cl(styles.label, labelClassName)}>
        {!small && t('component.exportToXlsx.button')}
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={cl(styles.arrowIcon, expanded && styles.expanded)}
        >
          <path
            d="M2.91536 10.5923L6.9987 6.05525L11.082 10.5923"
            stroke="#FFF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div
        className={cl(styles.list, expanded && styles.expanded)}
        onClick={(e) => {
          e.stopPropagation();
        }}
        ref={listRef}
      >
        <div style={{ minHeight: 0 }}>
          {exportModes.map((mode) => (
            <div
              key={`export-select-${mode}`}
              className={styles.listItem}
              onClick={() => {
                onExport(mode);
                setExpanded(false);
              }}
            >
              {td(`component.exportToXlsx.${mode}`)}
            </div>
          ))}
        </div>
      </div>
    </button>
  );
};

type ExportModalProps = {
  show: boolean;
  close: () => void;
};

export const ExportModal = ({ show, close }: ExportModalProps) => {
  const { t } = useLanguage();

  return (
    <Modal
      show={show}
      close={close}
      header={t('component.exportToXlsx.modal.title')}
      className={styles.modal}
      footer={
        <div className={styles.modalButtons}>
          <Button
            label={t('general.cancel')}
            onClick={close}
            className={styles.closeBtn}
            design="outlineBlue"
            autoSize
          />
        </div>
      }
      closeOnEsc
    >
      <div className={styles.modalContent}>
        <div className={styles.modalDescription}>
          {t('component.exportToXlsx.modal.description')}
        </div>
        <div className={styles.loader} />
      </div>
    </Modal>
  );
};

export const getExportDates = (mode: ExportMode): CalendarDate[] => {
  if (mode === 'current') {
    return [new CalendarDate().setFirstDay(), new CalendarDate().setLastDay()];
  }

  const date = new CalendarDate().setFirstDay();

  if (date.month === 1) {
    date.month = 12;
    date.year -= 1;
  } else {
    date.month -= 1;
  }

  return [date.setFirstDay(), new CalendarDate(date.date).setLastDay()];
};
